const autorizar_correcao_em_relatorio_final_da_escola = [
  {
    path: "/autorizar-correcao-em-relatorio-final-da-escola",
    name: "autorizar_correcao_em_relatorio_final_da_escola",
    meta: {
      allowedPermissions: ["relatoriofinal_autorizar_correcao"],
      breadCrumb: "Processo de Resultado Final - Relatório Final da Escola",
    },
    component: () =>
      import(
        "@/views/AutorizarCorrecaoEmRelatorioFinalDaEscola/AutorizarCorrecaoEmRelatorioFinalDaEscola.vue"
      ),
  },
];

export { autorizar_correcao_em_relatorio_final_da_escola };
